import React from 'react';

export enum Lights {
  Green = 'green',
  Red = 'red',
  Yellow = 'yellow',
  Blue = 'blue',
  Indigo = 'indigo',
  Grey = 'grey',
}

interface StatusLightComponent {
  color: Lights;
}

const getHex = (color: Lights) => {
  switch (color) {
    case Lights.Green:
      return '#49D271';
    case Lights.Red:
      return '#FF1D52';
    case Lights.Yellow:
      return '#FFC900';
    case Lights.Blue:
      return '#0074FF';
    case Lights.Indigo:
      return '#6A5DF9';
    case Lights.Grey:
    default:
      return '#cccccc';
  }
};

const StatusLight = ({ color }: StatusLightComponent) => (
  <>
    <div />

    <style jsx>{`
      div {
        background: ${getHex(color)};
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 100%;
      }
    `}</style>
  </>
);

export default StatusLight;
